var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: {
        name: "event-registration-agreement-modal",
        scrollable: true,
        adaptive: true,
        height: "auto",
      },
    },
    [
      _c("div", { staticClass: "container-fluid wa-modal" }, [
        _c("div", { staticClass: "row wa-modal-header" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("h2", [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(_vm.$t("event_registration.tos_modal_title")) +
                  "\n\t\t\t\t"
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.event.tos_text) } }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "footer",
          { staticClass: "row wa-modal-footer wa-modal-footer-white" },
          [
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "pull-right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-default btn-inverted",
                    attrs: { href: "#", id: "agreement-modal-close-button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.close.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("common.close")) +
                        "\n\t\t\t\t\t"
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }